/* Flowin theme — vanilla JS, no dependencies */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = window.Flowin && window.Flowin.money ? window.Flowin.money : function (c) {
    return "R$ " + (c / 100).toFixed(2).replace(".", ",");
  };

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = $("[data-drawer]");
    if (!drawer) return;
    function open() { drawer.classList.add("is-open"); document.body.style.overflow = "hidden"; }
    function close() { drawer.classList.remove("is-open"); document.body.style.overflow = ""; }
    $$("[data-drawer-open]").forEach(function (b) { b.addEventListener("click", open); });
    $$("[data-drawer-close]").forEach(function (b) { b.addEventListener("click", close); });
    $(".drawer__scrim", drawer) && $(".drawer__scrim", drawer).addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    $$("[data-faq-item]").forEach(function (item) {
      var q = $(".faq__q", item), a = $(".faq__a", item);
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.toggle("is-open");
        q.setAttribute("aria-expanded", open);
        a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
      });
    });
  }

  /* ---------- Buy box (offer selection + add to cart) ---------- */
  function initBuyBox() {
    $$("[data-buybox]").forEach(function (box) {
      var offers = $$("[data-offer]", box);
      var qtyInput = $("[data-buy-qty]", box);
      var idInput = $("[data-buy-id]", box);
      if (!offers.length) return;
      function select(offer) {
        offers.forEach(function (o) { o.classList.remove("is-active"); o.setAttribute("aria-checked", "false"); });
        offer.classList.add("is-active");
        offer.setAttribute("aria-checked", "true");
        if (qtyInput) qtyInput.value = offer.getAttribute("data-qty") || 1;
        // reflect on sticky bar price
        var stickyPrice = $("[data-sticky-price]");
        var total = offer.getAttribute("data-total");
        if (stickyPrice && total) stickyPrice.textContent = total;
      }
      offers.forEach(function (o) {
        o.addEventListener("click", function () { select(o); });
        o.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(o); }
        });
      });
      select(offers[0]);
    });
  }

  /* ---------- AJAX add to cart ---------- */
  function initAddToCart() {
    $$("[data-add-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        // graceful: if fetch unsupported, let it POST normally
        if (!window.fetch) return;
        e.preventDefault();
        var btn = $("[type=submit]", form);
        var original = btn ? btn.innerHTML : "";
        if (btn) { btn.disabled = true; btn.innerHTML = "Adicionando…"; }
        var data = new FormData(form);
        fetch("/cart/add.js", { method: "POST", body: data, headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (btn) { btn.innerHTML = "✓ Adicionado"; }
            setTimeout(function () {
              if (btn) { btn.disabled = false; btn.innerHTML = original; }
              if (window.FlowinCart && document.querySelector("[data-cart-drawer]")) {
                window.FlowinCart.open();
              } else {
                window.location.href = "/cart";
              }
            }, 400);
          })
          .catch(function () { form.submit(); });
      });
    });
  }
  function updateCartCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n; el.style.display = n > 0 ? "grid" : "none";
    });
  }

  /* ---------- Sticky mobile add-to-cart ---------- */
  function initSticky() {
    var bar = $("[data-sticky-atc]");
    var anchor = $("[data-buybox]") || $("[data-sticky-anchor]");
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // show bar when the main buy box is scrolled out of view
        bar.classList.toggle("is-visible", !en.isIntersecting && window.scrollY > 400);
      });
    }, { rootMargin: "-60% 0px 0px 0px" });
    io.observe(anchor);
    var stickyBtn = $("[data-sticky-buy]", bar);
    if (stickyBtn) stickyBtn.addEventListener("click", function () {
      var active = $("[data-buybox] .offer.is-active") || $("[data-buybox] [data-offer]");
      var form = $("[data-add-form]");
      if (active && form) {
        var q = $("[data-buy-qty]", form);
        if (q) q.value = active.getAttribute("data-qty") || 1;
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();
      }
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    $$("[data-countdown]").forEach(function (el) {
      var mins = parseInt(el.getAttribute("data-minutes") || "15", 10);
      var key = "flowin_cd_" + (el.getAttribute("data-key") || "default");
      var end = parseInt(sessionStorage.getItem(key) || "0", 10);
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; sessionStorage.setItem(key, end); }
      var mEl = $("[data-cd-m]", el), sEl = $("[data-cd-s]", el);
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        var m = Math.floor(left / 60), s = left % 60;
        if (mEl) mEl.textContent = ("0" + m).slice(-2);
        if (sEl) sEl.textContent = ("0" + s).slice(-2);
        if (left <= 0) return;
        requestAnimationFrame(function () { setTimeout(tick, 500); });
      }
      tick();
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $$(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Cart quantity (cart page) ---------- */
  function initCartQty() {
    $$("[data-qty]").forEach(function (wrap) {
      var input = $("input", wrap);
      $$("[data-step]", wrap).forEach(function (b) {
        b.addEventListener("click", function () {
          var v = parseInt(input.value, 10) || 1;
          v += parseInt(b.getAttribute("data-step"), 10);
          if (v < 0) v = 0;
          input.value = v;
          var form = input.closest("form");
          if (form) form.submit();
        });
      });
    });
  }

  /* ---------- Variant selector (product page) ---------- */
  function initVariants() {
    $$("[data-product-form]").forEach(function (form) {
      var dataEl = $("[data-variants]", form);
      var idInput = $("[data-variant-id]", form);
      if (!dataEl || !idInput) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = $$("select[data-option-index]", form);
      if (!selects.length) return;
      var priceEl = $("[data-variant-price]");
      var submit = $("[type=submit]", form);
      function update() {
        var chosen = selects.map(function (s) { return s.value; });
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? "Adicionar ao carrinho" : "Esgotado";
        }
      }
      selects.forEach(function (s) { s.addEventListener("change", update); });
      update();
    });
  }


  /* ---------- Carrossel do hero ---------- */
  function initGallery() {
    $$("[data-gallery]").forEach(function (g) {
      var track = $("[data-gallery-track]", g);
      var dots = $$("[data-gallery-dot]", g);
      var prev = $("[data-gallery-prev]", g);
      var next = $("[data-gallery-next]", g);
      if (!track) return;
      var slides = $$(".gallery__slide", track);
      if (slides.length < 2) return;

      function current() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }
      function goTo(i) {
        var n = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: n * track.clientWidth, behavior: "smooth" });
      }
      function sync() {
        var i = current();
        dots.forEach(function (d, j) { d.classList.toggle("is-active", j === i); });
        if (prev) prev.style.opacity = i === 0 ? ".35" : "1";
        if (next) next.style.opacity = i === slides.length - 1 ? ".35" : "1";
      }
      if (prev) prev.addEventListener("click", function () { goTo(current() - 1); });
      if (next) next.addEventListener("click", function () { goTo(current() + 1); });
      dots.forEach(function (d) {
        d.addEventListener("click", function () { goTo(parseInt(d.getAttribute("data-gallery-dot"), 10)); });
      });
      var t;
      track.addEventListener("scroll", function () { clearTimeout(t); t = setTimeout(sync, 90); });
      window.addEventListener("resize", sync);
      sync();

      /* autoplay opcional, com pausa ao interagir.
         Só faz sentido no modo carrossel — na grade do desktop o track não rola. */
      function isCarousel() {
        return track.scrollWidth > track.clientWidth + 4;
      }
      if (g.getAttribute("data-autoplay") === "true") {
        var secs = parseInt(g.getAttribute("data-interval"), 10) || 5;
        var timer = null, paused = false;
        function tick() {
          if (paused || document.hidden || !isCarousel()) return;
          var i = current();
          goTo(i >= slides.length - 1 ? 0 : i + 1);
        }
        function start() { if (!timer) timer = setInterval(tick, secs * 1000); }
        function stop() { clearInterval(timer); timer = null; }
        ["mouseenter", "touchstart", "focusin"].forEach(function (ev) {
          g.addEventListener(ev, function () { paused = true; }, { passive: true });
        });
        ["mouseleave", "focusout"].forEach(function (ev) {
          g.addEventListener(ev, function () { paused = false; });
        });
        g.addEventListener("touchend", function () {
          setTimeout(function () { paused = false; }, 4000);
        }, { passive: true });
        document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });
        start();
      }
    });
  }

  /* ---------- Carrinho lateral (drawer) com URL para tageamento ---------- */
  var CartDrawer = (function () {
    var prevUrl = null;
    function el() { return $("[data-cart-drawer]"); }

    function tag(event, data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, data || {}));
    }

    function pushUrl() {
      var target = (window.Flowin && window.Flowin.cartDrawerUrl) || "";
      if (!target) return;
      try {
        prevUrl = window.location.pathname + window.location.search;
        if (prevUrl !== target) {
          window.history.pushState({ flowinCart: true }, "", target);
          tag("cart_drawer_open", { page_path: target });
        }
      } catch (e) {}
    }
    function restoreUrl() {
      if (!prevUrl) return;
      try {
        if (window.history.state && window.history.state.flowinCart) {
          window.history.pushState({}, "", prevUrl);
        }
        tag("cart_drawer_close", { page_path: prevUrl });
      } catch (e) {}
      prevUrl = null;
    }

    function render(cart) {
      var body = $("[data-cart-body]"), foot = $("[data-cart-foot]"), total = $("[data-cart-total]");
      if (!body) return;
      if (!cart || !cart.items || !cart.items.length) {
        var d0 = $("[data-cart-drawer]");
        var emptyMsg = (d0 && d0.getAttribute("data-empty-text")) || "Seu carrinho está vazio.";
        body.innerHTML = '<div class="cart-drawer__empty">' + emptyMsg + '</div>';
        if (foot) foot.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? '<img class="cd-item__img" src="' + it.image + '" alt="" width="72" height="90">' : '<div class="cd-item__img"></div>';
        var variant = (it.variant_title && it.variant_title !== "Default Title") ? '<div class="cd-item__v">' + it.variant_title + "</div>" : "";
        return '<div class="cd-item" data-line="' + (i + 1) + '">' + img +
          '<div><div class="cd-item__t">' + it.product_title + "</div>" + variant +
          '<div class="cd-qty"><button data-cd-minus aria-label="Diminuir">–</button><span>' + it.quantity + '</span><button data-cd-plus aria-label="Aumentar">+</button></div>' +
          '<button class="cd-item__rm" data-cd-remove>remover</button></div>' +
          '<div class="cd-item__price">' + money(it.final_line_price) + "</div></div>";
      }).join("");
      if (total) total.textContent = money(cart.total_price);
      if (foot) foot.hidden = false;
      bindLines();
    }

    function update(line, qty) {
      var body = $("[data-cart-body]");
      if (body) body.classList.add("cart-drawer__loading");
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          syncCount(cart.item_count);
          if (body) body.classList.remove("cart-drawer__loading");
        })
        .catch(function () { if (body) body.classList.remove("cart-drawer__loading"); });
    }

    function bindLines() {
      $$("[data-cd-minus]").forEach(function (b) {
        b.addEventListener("click", function () {
          var row = b.closest("[data-line]"), q = parseInt($("span", $(".cd-qty", row)).textContent, 10);
          update(parseInt(row.getAttribute("data-line"), 10), Math.max(0, q - 1));
        });
      });
      $$("[data-cd-plus]").forEach(function (b) {
        b.addEventListener("click", function () {
          var row = b.closest("[data-line]"), q = parseInt($("span", $(".cd-qty", row)).textContent, 10);
          update(parseInt(row.getAttribute("data-line"), 10), q + 1);
        });
      });
      $$("[data-cd-remove]").forEach(function (b) {
        b.addEventListener("click", function () {
          var row = b.closest("[data-line]");
          update(parseInt(row.getAttribute("data-line"), 10), 0);
        });
      });
    }

    function syncCount(n) {
      $$(".cart-count").forEach(function (c) {
        c.textContent = n;
        c.style.display = n > 0 ? "" : "none";
      });
    }

    function fetchCart() {
      return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
    }

    function open() {
      var d = el();
      if (!d) return;
      d.classList.add("is-open");
      d.setAttribute("aria-hidden", "false");
      document.body.classList.add("cart-open");
      pushUrl();
      fetchCart()
        .then(function (cart) { render(cart); syncCount(cart.item_count); })
        .catch(function () {
          var body = $("[data-cart-body]");
          var dE = $("[data-cart-drawer]");
          var errMsg = (dE && dE.getAttribute("data-error-text")) || "Não foi possível carregar o carrinho. Tente novamente.";
          if (body) body.innerHTML = '<div class="cart-drawer__empty">' + errMsg + '</div>';
        });
    }
    function close() {
      var d = el();
      if (!d) return;
      d.classList.remove("is-open");
      d.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cart-open");
      restoreUrl();
    }
    return { open: open, close: close, render: render, syncCount: syncCount, fetchCart: fetchCart };
  })();

  function initCartDrawer() {
    if (!$("[data-cart-drawer]")) return;
    $$("[data-cart-close]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); CartDrawer.close(); });
    });
    // ícone do carrinho abre o drawer em vez de navegar
    $$('a[href$="/cart"], a[href*="/cart?"], [data-cart-open]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (a.hasAttribute("data-cart-no-drawer")) return;
        e.preventDefault();
        CartDrawer.open();
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") CartDrawer.close();
    });
    window.addEventListener("popstate", function () {
      var d = $("[data-cart-drawer]");
      if (d && d.classList.contains("is-open")) CartDrawer.close();
    });
    CartDrawer.fetchCart().then(function (c) { CartDrawer.syncCount(c.item_count); }).catch(function () {});
  }
  window.FlowinCart = CartDrawer;


  /* ---------- Mini players ---------- */
  function initMiniPlayers() {
    $$("[data-mini-player]").forEach(function (frame) {
      var v = frame.querySelector("video");
      var btn = frame.querySelector("[data-mini-toggle]");
      if (!v || !btn) { if (btn && !v) btn.style.display = frame.querySelector("a") ? "" : "none"; return; }
      btn.addEventListener("click", function () {
        $$("[data-mini-player] video").forEach(function (o) {
          if (o !== v) { o.pause(); o.closest("[data-mini-player]").classList.remove("is-playing"); }
        });
        if (v.paused) { v.play(); frame.classList.add("is-playing"); }
        else { v.pause(); frame.classList.remove("is-playing"); }
      });
      v.addEventListener("click", function () {
        v.pause(); frame.classList.remove("is-playing");
      });
      v.addEventListener("ended", function () { frame.classList.remove("is-playing"); });
    });
  }


  /* ---------- Checkout externo direto (Yampi) ----------
     Replica o fluxo oficial: /cart.json -> API Yampi -> checkout_direct_url.
     Reaproveita as funções globais do script deles quando existirem. */
  function initExternalCheckout() {
    var btn = $("[data-external-checkout]");
    if (!btn) return;

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (btn.dataset.busy === "1") return;
      btn.dataset.busy = "1";

      var endpoint = btn.getAttribute("data-endpoint");
      var domain = btn.getAttribute("data-shop-domain");
      var clearCart = btn.getAttribute("data-clear-cart") === "true";
      var original = btn.innerHTML;
      btn.innerHTML = btn.getAttribute("data-loading-label") || "Redirecionando...";
      btn.setAttribute("aria-busy", "true");
      if (typeof window.showYampiLoader === "function") {
        try { window.showYampiLoader(); } catch (err) {}
      }

      function fail() {
        if (typeof window.hideYampiLoader === "function") {
          try { window.hideYampiLoader(); } catch (err) {}
        }
        btn.dataset.busy = "0";
        btn.innerHTML = original;
        btn.removeAttribute("aria-busy");
        window.location.href = "/cart";
      }

      fetch("/cart.json", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cartPayload) {
          if (!cartPayload || !cartPayload.item_count) { throw new Error("carrinho vazio"); }
          return fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              shop: window.location.host,
              shopify_internal_domain: domain,
              cart_payload: cartPayload
            })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (raw) {
          var resp = raw && raw.data ? raw.data : raw;
          var url = resp && resp.checkout_direct_url;
          if (!url) { throw new Error("sem checkout_direct_url"); }
          if (typeof window.ymp_getUrlWithUtms === "function") {
            try { url = window.ymp_getUrlWithUtms(url); } catch (err) {}
          }
          if (!clearCart) { window.location.href = url; return; }
          return fetch("/cart/clear.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: "{}"
          }).catch(function () {}).then(function () { window.location.href = url; });
        })
        .catch(fail);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initDrawer(); initFaq(); initBuyBox(); initAddToCart();
    initSticky(); initCountdown(); initReveal(); initCartQty(); initVariants();
    initGallery(); initCartDrawer(); initMiniPlayers(); initExternalCheckout();
  });
})();
